var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPreferences(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25 4.5H4.63875C4.94925 5.37075 5.7735 6 6.75 6C7.7265 6 8.55075 5.37075 8.86125 4.5H15.75C16.1648 4.5 16.5 4.16475 16.5 3.75C16.5 3.33525 16.1648 3 15.75 3H8.86125C8.55075 2.12925 7.7265 1.5 6.75 1.5C5.7735 1.5 4.94925 2.12925 4.63875 3H2.25C1.83525 3 1.5 3.33525 1.5 3.75C1.5 4.16475 1.83525 4.5 2.25 4.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 8.25H13.3613C13.0508 7.37925 12.2265 6.75 11.25 6.75C10.2735 6.75 9.44925 7.37925 9.13875 8.25H2.25C1.83525 8.25 1.5 8.58525 1.5 9C1.5 9.41475 1.83525 9.75 2.25 9.75H9.13875C9.44925 10.6207 10.2743 11.25 11.25 11.25C12.2258 11.25 13.0508 10.6207 13.3613 9.75H15.75C16.1648 9.75 16.5 9.41475 16.5 9C16.5 8.58525 16.1648 8.25 15.75 8.25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 13.5H8.86125C8.55075 12.6292 7.72575 12 6.75 12C5.77425 12 4.94925 12.6292 4.63875 13.5H2.25C1.83525 13.5 1.5 13.8353 1.5 14.25C1.5 14.6648 1.83525 15 2.25 15H4.63875C4.94925 15.8707 5.7735 16.5 6.75 16.5C7.7265 16.5 8.55075 15.8707 8.86125 15H15.75C16.1648 15 16.5 14.6648 16.5 14.25C16.5 13.8353 16.1648 13.5 15.75 13.5Z",
    fill: "black"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreferences);
export default __webpack_public_path__ + "static/media/preferences.5971540f89e656ba40887515bfc04a11.svg";
export { ForwardRef as ReactComponent };